import ReactDOM from 'react-dom/client'
import './index.css'
import Routes from './Routes.tsx';
// import NotificationContainer from './notificationContainer.jsx';
ReactDOM.createRoot(document.getElementById('root')!).render(
    <Routes />
)
